export default __webpack_public_path__ + "static/1-fb81df073ddff4945a7559535faa4c74.jpg";